var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.keys = void 0;
  function keys(object) {
    return Object.keys(object);
  }
  exports.keys = keys;
  return exports;
}